export const getBackendBaseUrl = () => {
  if (typeof window !== "undefined") {
    const hostname = window.location.hostname;
    if (hostname === "localhost" || hostname === "127.0.0.1") {
      return "http://localhost:8080";
    }
  }
  return process.env.REACT_APP_API_URL || "https://rc3t9mm4e4.execute-api.ap-south-1.amazonaws.com/dev";
};
